import styled from 'styled-components'

interface PinWrapperProps {
  css: string
}

export const PinWrapper = styled.div<PinWrapperProps>`
  ${(props) => props.css}
  position: absolute;
  cursor: pointer;
  width: fit-content;
  height: fit-content;
  /* border: 2px solid red; */

  /* &:hover {
    .pinText {
      font-weight: 800;
      letter-spacing: 2px;
      color: #FFC600;
      text-shadow: -3px -3px 3px rgba(255,255,255,.1), 3px 3px 3px rgba(0,0,0,.7);
    }
  } */
  .pinImage {
    width: 100%;
    ${(props) => props.pinImageCss}
  }

  .textParent {
    perspective: 200px;
    position: absolute;
    z-index: 1000;
    inset: 0;
  }
  .pinText {
    color: #052e68;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 1px;
    
    z-index: 1000;
    text-align: center;
    transform-style: preserve-3d;
    transition: all 300ms ease-in;
    animation: float 3s ease-in-out infinite;
    ${(props) => props.textCss}

    span span {
      position: relative;
      bottom: -1em;
      opacity: 0;
      animation: move-text 3s infinite forwards;
    }

    @media (min-width: 1440px) {
      font-size: 16px;
    }
  }

  .glow {
    animation: glowPulse 2s infinite;
  }

  @keyframes move-text {
    0% {
      bottom: -0.25em;
      opacity: 1;
    }
    50% {
      bottom: 0.25em;
    }
    100% {
      bottom: 0;
      opacity: 1;
    }
  }

  @keyframes float {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-8px);
    }
    100% {
      transform: translateY(0);
    }
  }

  @keyframes glowPulse {
    0% {
      box-shadow: 0 0 5px rgba(250, 255, 0, 0.2), 0 0 10px rgba(250, 255, 0, 0.4), 0 0 15px rgba(250, 255, 0, 0.6), 0 0 20px rgba(250, 255, 0, 0.8);
    }
    50% {
      box-shadow: 0 0 15px rgba(250, 255, 0, 0.4), 0 0 20px rgba(250, 255, 0, 0.6), 0 0 30px rgba(250, 255, 0, 0.8), 0 0 40px rgba(250, 255, 0, 1);
    }
    100% {
      box-shadow: 0 0 5px rgba(250, 255, 0, 0.2), 0 0 10px rgba(250, 255, 0, 0.4), 0 0 15px rgba(250, 255, 0, 0.6), 0 0 20px rgba(250, 255, 0, 0.8);
    }
  }
`
